<div class="dialog">
  <div class="composition">
    <div class="title title-margin-top">
      <h3>{{ 'dialog_complex_product_title' | translate }}</h3>
    </div>
    <div>
      <mat-accordion hideToggle>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header #panel (click)="panel._toggle()">
            <mat-panel-title>
              <div class="row text-bold">
                <div class="col-1 text-center"></div>
                <div class="col-1">{{ 'common_field_code' | translate }}</div>
                <div class="col-2">{{ 'common_field_label' | translate }}</div>
                <div class="col-2">{{ 'common_field_transport' | translate }}</div>
                <div class="col-1">{{ 'common_field_energy' | translate }}</div>
                <div class="col-1">{{ 'common_field_distance' | translate }}</div>
                <div class="col-1 text-center">{{ 'dialog_complex_product_col_double_freight' | translate }}</div>
                <div class="col-1 text-center">{{ 'dialog_formula_composition_col_multimodal' | translate }}</div>
                <div class="col-1"></div>
                <div class="col-1">{{ 'dialog_edit_composition_field_ratio' | translate }}</div>
                <div class="col-1"></div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngIf="currentItem?.produits && currentItem?.produits?.length">
            <div class="row" [ngClass]="{ backgroundColor: indexPro % 2 == 0 }" *ngFor="let item of currentItem?.produits; let indexPro = index">
              <div class="col-1 text-center">
                <badge-statut itemType="blue"></badge-statut>
              </div>
              <div class="col-1">
                {{ item.code }}
              </div>
              <div class="col-2 align-center">
                {{ item.displayName }}
              </div>
              <div class="col-2">
                <span>{{ item.transportName ? item.transportName : ('common_no_transport' | translate) }} </span>
              </div>
              <div class="col-1">
                <div *ngIf="!item.isMultimodal">
                  {{ item?.energyName ? item?.energyName : ('common_no_energy' | translate) }}
                </div>
              </div>
              <div class="col-1">
                <div *ngIf="!item.isMultimodal">
                  {{ item.distance }}
                </div>
              </div>
              <div class="col-1">
                <div *ngIf="!item.isMultimodal">
                  <mat-checkbox [checked]="item?.doubleCargo ? true : false" disabled> </mat-checkbox>
                </div>
              </div>
              <div class="col-1 text-center icon-color"></div>
              <div class="col-1 text-center ratio">{{ item.ratio }}%</div>
            </div>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
